export default "__VITE_ASSET__BQV9m$WM__"